import {CLIENT, HAO_DOMAIN, removeLocal} from "helpers/utils.js";

export function fetchMessages(offset, limit, setMessages, setPagination) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/messages?page=${offset}&limit=${limit}`;

  return fetch(url, {method: 'GET', credentials: 'include'}).then(res => {
    if (res.status === 200) {
      return res.json();
    } else if (res.status === 401) {
      removeLocal('user');
    }
    throw new Error(`Failed to fetch messages: ${res.status}`);
  }).then(data => {
    if (setMessages) setMessages(data?.messages || []);
    if (setPagination) setPagination(data?.pagination || {});
    return data;
  }).catch(err => {
    console.error('Error fetching messages:', err);
    if (setMessages) setMessages([]);
    if (setPagination) setPagination({});
    removeLocal('user');
    throw err;
  });
}

export function createMessage(messageData) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/messages`;

  return fetch(url, {method: 'POST', credentials: 'include',
    body: JSON.stringify(messageData)
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to create message: ${res.status}`);
  }).then(data => {
    console.log('Message created successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error creating message:', err);
    throw err; // Re-throw to be handled by the calling component
  });
}

export function updateMessage(messageId, messageData) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/messages/${messageId}`;

  return fetch(url, {method: 'PUT', credentials: 'include',
    body: JSON.stringify(messageData)
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw new Error(`Failed to update message: ${res.status}`);
    }
  }).then(data => {
    console.log('Message updated successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error updating message:', err);
    throw err;
  });
}

export function deleteMessage(messageId) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/messages/${messageId}`;

  return fetch(url, {
    method: 'DELETE',
    credentials: 'include'
  }).then(res => {
    if (res.status === 200) {
      return true;
    } else {
      throw new Error(`Failed to delete message: ${res.status}`);
    }
  }).then(() => {
    console.log('Message deleted successfully');
    return true;
  }).catch(err => {
    console.error('Error deleting message:', err);
    throw err;
  });
}
